import { render, staticRenderFns } from "./OrderReceipt.vue?vue&type=template&id=6bc4571a&"
import script from "./OrderReceipt.vue?vue&type=script&lang=js&"
export * from "./OrderReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports